export default __webpack_public_path__ + "static/media/linkedin.61a71fb3.svg";